import PropTypes from 'prop-types';

/**
 * Reusable loading spinner component.
 *
 * @param {Object} props
 * @param {string} props.size - Size variant: 'sm', 'md', 'lg' (default: 'md')
 * @param {boolean} props.fullScreen - Whether to center in full screen (default: false)
 */
function LoadingSpinner({ size, fullScreen }) {
  const sizeClasses = {
    sm: 'h-6 w-6',
    md: 'h-12 w-12',
    lg: 'h-16 w-16',
  };

  const spinner = (
    <div
      className={`animate-spin rounded-full border-b-2 border-puzzle-blue ${sizeClasses[size]}`}
    />
  );

  if (fullScreen) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        {spinner}
      </div>
    );
  }

  return spinner;
}

LoadingSpinner.propTypes = {
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  fullScreen: PropTypes.bool,
};

LoadingSpinner.defaultProps = {
  size: 'md',
  fullScreen: false,
};

export default LoadingSpinner;
